export const viewedVehiclesLocalStorage = {
    key: 'viewedVehicles',
};

export enum VehicleStatuses {
    Sold = 'Sold',
    OnTestDrive = 'On Test Drive',
    Reserved = 'Reserved',
    Shipping = 'Shipping',
    ComingSoon = 'Coming Soon',
    OffSite = 'Off Site',
    NotAvailable = 'Not Available',
}
export const soldVehicleStatusCodes = [360, 370, 760];
export const onTestDriveStatusCodes = [340, 345, 740];
export const reservedStatusCodes = [347, 350, 747, 750];
export const reservedConditionalStatusCodes = [330, 730];
export const shippingStatusCodes = [640, 650];
export const shippingConditionalStatusCodes = [100];
export const otherUnavailableStatusCodes = [250, 270, 300, 320, 325, 700, 720, 725];
export const statusCodesForUnavailableVehicles = [
    ...soldVehicleStatusCodes,
    ...onTestDriveStatusCodes,
    ...reservedStatusCodes,
    ...reservedConditionalStatusCodes,
    ...shippingStatusCodes,
    ...shippingConditionalStatusCodes,
    ...otherUnavailableStatusCodes,
];

export enum ProgressionActivities {
    ReservationRequested = 'ReservationRequested',
    ReservationCreated = 'ReservationCreated',
    ReservationUpdated = 'ReservationUpdated',
    ReservationCancelled = 'ReservationCancelled',
    ReservationRemoved = 'ReservationRemoved',
    ReservationFailed = 'ReservationFailed',
    VehicleOrderCreated = 'VehicleOrderCreated',
    VehicleOrderSubmitted = 'VehicleOrderSubmitted',
    VehicleOrderDeleted = 'VehicleOrderDeleted',
    MaxCareSelected = 'MaxCareSelected',
    MaxCareRemoved = 'MaxCareRemoved',
    PreQualificationsSubmitted = 'Pre-QualificationsSubmitted',
    PreQualificationsReceivingDone = 'Pre-QualificationsReceivingDone',
    PreQualificationsExpired = 'Pre-QualificationsExpired',
    CreditApplicationSubmitted = 'CreditApplicationSubmitted',
    CreditApplicationDecisionReceived = 'CreditApplicationDecisionReceived',
    CreditApplicationExpired = 'CreditApplicationExpired',
    CreditApplicationViewed = 'CreditApplicationViewed',
    CreditApplicationSaved = 'CreditApplicationSaved',
    InstantOfferCompleted = 'InstantOfferCompleted',
    TransferCheckoutCreated = 'TransferCheckoutCreated',
    TransferCheckoutCompleted = 'TransferCheckoutCompleted',
    TransferCheckoutAbandoned = 'TransferCheckoutAbandoned',
    TransferOrderRequestSubmitted = 'TransferOrderRequestSubmitted',
    TransferOrderAwaitingApproval = 'TransferOrderAwaitingApproval',
    TransferOrderApproved = 'TransferOrderApproved',
    TransferOrderDenied = 'TransferOrderDenied',
    TransferOrderCancelled = 'TransferOrderCancelled',
    TransferOrderTendered = 'TransferOrderTendered',
    TransferOrderCompleted = 'TransferOrderCompleted',
    PayoffAmountVerified = 'PayoffAmountVerified',
    PayoffCreated = 'PayoffCreated',
    VehicleAcquisitionOrderCreated = 'VehicleAcquisitionOrderCreated',
    DocumentRequested = 'DocumentRequested',
    DocumentUploaded = 'DocumentUploaded',
    DocumentTransactionCompleted = 'DocumentTransactionCompleted',
    SavedSearchCreated = 'SavedSearchCreated',
    SavedSearchUpdated = 'SavedSearchUpdated',
    SavedSearchRemoved = 'SavedSearchRemoved',
    AppointmentScheduled = 'AppointmentScheduled',
    AppointmentConfirmed = 'AppointmentConfirmed',
    AppointmentRescheduled = 'AppointmentRescheduled',
    AppointmentCanceled = 'AppointmentCanceled',
    TestDriveScheduled = 'TestDrive-TestDriveScheduled',
}

export enum AppointmentTypes {
    TEST_DRIVE = 'TestDrive',
}

export const STATE_ABBREVIATIONS: Record<string, string> = {
    Alabama: 'AL',
    Alaska: 'AK',
    Arizona: 'AZ',
    Arkansas: 'AR',
    California: 'CA',
    Colorado: 'CO',
    Connecticut: 'CT',
    Delaware: 'DE',
    'District of Columbia': 'DC',
    Florida: 'FL',
    Georgia: 'GA',
    Hawaii: 'HI',
    Idaho: 'ID',
    Illinois: 'IL',
    Indiana: 'IN',
    Iowa: 'IA',
    Kansas: 'KS',
    Kentucky: 'KY',
    Louisiana: 'LA',
    Maine: 'ME',
    Maryland: 'MD',
    Massachusetts: 'MA',
    Michigan: 'MI',
    Minnesota: 'MN',
    Mississippi: 'MS',
    Missouri: 'MO',
    Montana: 'MT',
    Nebraska: 'NE',
    Nevada: 'NV',
    'New Hampshire': 'NH',
    'New Jersey': 'NJ',
    'New Mexico': 'NM',
    'New York': 'NY',
    'North Carolina': 'NC',
    'North Dakota': 'ND',
    Ohio: 'OH',
    Oklahoma: 'OK',
    Oregon: 'OR',
    Pennsylvania: 'PA',
    'Rhode Island': 'RI',
    'South Carolina': 'SC',
    'South Dakota': 'SD',
    Tennessee: 'TN',
    Texas: 'TX',
    Utah: 'UT',
    Vermont: 'VT',
    Virginia: 'VA',
    Washington: 'WA',
    'West Virginia': 'WV',
    Wisconsin: 'WI',
    Wyoming: 'WY',
};

export const MOBILE_TABLET_BREAKPOINT = 900;
export const FULL_STORY_HOME_PAGE_ID = 'HP';
export const MAX_RECENTLY_VIEWED_VEHICLE_TILES = 10;
export const DAYS_BEFORE_HOMEBASE_VISITOR_EXPIRES = 30;
